import {FC, useState} from "react";
import {Input} from "@components/ui/input";
import {Label} from "@components/ui/label";
import {Card, CardContent, CardHeader, CardTitle} from "@components/ui/card";
import {isManagedRule, RuleStatus, RuleType} from "@types";
import {ToggleSwitch} from "@components/ui/toggle-switch.tsx";

export type FormProps = {
    id: string;
    name: string;
    status: RuleStatus,
    type: RuleType,
    onChange: (name: string, status: RuleStatus) => void;
};

export const Form: FC<FormProps> = ({id, name, status, type, onChange}) => {
    const [ruleName, setRuleName] = useState(name);

    return (
        <Card
            className="rounded-none bg-gradient-to-br from-orange-100/20 via-orange-50/10 to-transparent backdrop-blur-md shadow-xl">
            <CardHeader>
                <CardTitle className="text-lg font-semibold text-orange-300 drop-shadow-sm text-center">
                    {ruleName}
                </CardTitle>
            </CardHeader>

            <CardContent className="space-y-6">
                <div className="flex items-center space-x-4">
                    <Label htmlFor="rule-name" className="text-orange-200 font-medium">
                        Name
                    </Label>
                    <Input
                        key={`rule-name-${id}`}
                        id="rule-name"
                        type="text"
                        placeholder="Enter rule name"
                        value={ruleName}
                        className="rounded-lg bg-white/5 text-orange-100 placeholder-orange-100/40 border border-orange-200/40 focus:ring-2 focus:ring-orange-300 focus:outline-none backdrop-blur-sm"
                        onChange={(e) => {
                            const name = e.target.value;
                            setRuleName(() => {
                                onChange(name, status);
                                return name;
                            });
                        }}
                        disabled={isManagedRule(type)}
                    />
                </div>

                <StatusButton
                    id={id}
                    status={status}
                    onChange={(newStatus) => {
                        onChange(ruleName, newStatus);
                    }}
                />
            </CardContent>
        </Card>
    );
};


type StatusButtonProps = {
    id: string;
    status: RuleStatus;
    onChange: (value: RuleStatus) => void;
}

const StatusButton: FC<StatusButtonProps> = ({id, status, onChange}) => {
    const toggled =
        status === RuleStatus.ACTIVE || status === RuleStatus.ACTIVE_EXHAUSTED;

    return (
        <div className="pt-2 flex items-center space-x-4">
            <Label htmlFor="rule-status" className="text-orange-200 font-medium">
                Status
            </Label>
            <div className="w-full">
                <ToggleSwitch
                    activeLabel="Active"
                    inactiveLabel="Inactive"
                    value={toggled}
                    disabled={false}
                    onChange={() => {
                        switch (status) {
                            case RuleStatus.ACTIVE:
                                onChange(RuleStatus.INACTIVE);
                                break;
                            case RuleStatus.ACTIVE_EXHAUSTED:
                                onChange(RuleStatus.INACTIVE_EXHAUSTED);
                                break;
                            case RuleStatus.INACTIVE:
                                onChange(RuleStatus.ACTIVE);
                                break;
                            case RuleStatus.INACTIVE_EXHAUSTED:
                                onChange(RuleStatus.ACTIVE_EXHAUSTED);
                                break;
                        }
                    }}
                />
            </div>
        </div>
    );
};
